export default __webpack_public_path__ + "4a75296.png";